import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Link.module.scss';

function BongoLink(props) {
  return <Link className={styles.link} {...props} />;
}

export default BongoLink;
